export default {
    methods: {
        mountRecaptcha() {
            if (process.env.NODE_ENV === 'development') {
                // If it's development environment, we can skip loading reCAPTCHA and use a dummy token
                return Promise.resolve()
            }

            return new Promise((resolve, reject) => {
                if (typeof window.grecaptcha !== 'undefined') {
                    resolve(window.grecaptcha)
                    return
                }

                // Load the reCAPTCHA script
                const recaptchaScript = document.createElement('script')
                recaptchaScript.setAttribute(
                    'src',
                    `https://www.google.com/recaptcha/api.js?render=${process.env.VUE_APP_RECAPTCHA_SITE_KEY}`
                )
                document.head.appendChild(recaptchaScript)

                // Poll for grecaptcha presence
                const start = Date.now()
                const timeout = 5000;
                (function check() {
                    if (window.grecaptcha) {
                        resolve(window.grecaptcha)
                    } else if (Date.now() - start > timeout) {
                        reject(new Error('Could not load reCAPTCHA.'))
                    } else {
                        setTimeout(check, 50)
                    }
                })()
            })
        }
    }
}